import React, { Fragment } from 'react';
import { useDispatch } from 'react-redux';
import matchSorter from 'match-sorter';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { TIGHT_FIT_PARAM } from 'constants/System';
import ListRowCheckbox from 'components/ListRowCheckbox';

const SelectByIdTable = ({
    data,
    width,
    dispatchOnClick,
}) => {
    const smallWidth = width > TIGHT_FIT_PARAM ? 50 : 50; // TODO see how this works
    const styledSummaryColumn = (value) => {
        return <Fragment>
            <span className="d-inline-block text-black">
                <div className="font-weight-bold">{value}</div>
            </span>
        </Fragment>;
    };

    const dispatch = useDispatch();
    const styledActionColumn = (value) => {
        return <Fragment> 
            <ListRowCheckbox
                selected={value?.selected}
                onClick={() => dispatch(dispatchOnClick(value))} 
            />
        </Fragment>;
    };

    const actionColumn = {
        id: 'action',
        accessor: d => d,
        Cell: ({ value }) => {
            return styledActionColumn(value);
        },
        sortable: false, // need both sortable and filterable = false so col is not clickable
        filterable: false,
        width: smallWidth,
    };
    const summaryColumn = {
        Header: 'Description',
        id: 'name',
        accessor: d => d?.name,
        filterMethod: (filter, rows) =>
            matchSorter(rows, filter.value, { keys: ['name'] }),
        Cell: ({ value }) => {
            return styledSummaryColumn(value);
        },
        filterAll: true,
    };
    const columnsList = new Array();
    columnsList.push(actionColumn);
    columnsList.push(summaryColumn);
    return (
        <div>
            <ReactTable
                data={data}
                filterable
                defaultFilterMethod={(filter, row) =>
                    String(row[filter.id]) === filter.value}
                columns={[
                    {
                        columns: columnsList
                    }
                ]}
                defaultPageSize={data?.length <= 5 ? 5 : 10}
                className='-highlight'
            />
        </div>
    );
};

export default SelectByIdTable;


// WEBPACK FOOTER //
// ./components/selectByIdModal/selectByIdTable/index.js